import { Layout } from 'react-admin';
import { MyMenu } from '../MyMenu/MyMenu';
import { MyAppBar } from '../MyAppBar/MyAppBar';
import {
    AppLocationContext,
    Breadcrumb,
    ResourceBreadcrumbItems,
} from "@react-admin/ra-navigation";
// import { ReactQueryDevtools } from 'react-query/devtools'
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    breadcrumbContainer: {
        // backgroundColor: '#e0f7fa',
        // padding: '8px 16px',
        // borderRadius: '4px',
        marginTop: '30px',
    },
});



export const MyLayout = ({ children, ...props }) => {

    const classes = useStyles();

    return (
        <AppLocationContext hasDashboard>
            <Layout {...props} menu={MyMenu} appBar={MyAppBar}>
                <div className={classes.breadcrumbContainer}>
                    <Breadcrumb hasDashboard={true}>
                        <ResourceBreadcrumbItems />
                    </Breadcrumb>
                </div>
                {children}
            </Layout>
        </AppLocationContext>
    );

}